import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';

import PhraseMarkdownText from '../PhraseMarkdownText';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    minWidth: 210,
    backgroundColor: theme.palette.ava.blue,
    color: theme.palette.ava.white,
  },
  contained: {
    '&:hover': {
      background: theme.palette.ava.blue,
    },
  },
  label: {
    display: 'flex',
    flexDirection: 'column',
  },
  mainText: {
    fontSize: 20,
    fontWeight: 600,
  },
  subText: {
    marginTop: -10,
    fontSize: 16,
    opacity: 0.8,
  },
}));

const MobileDownloadButton = () => {
  const classes = useStyles();

  return (
    <a href="https://ava.app.link/download" target="_blank">
      <Button
        classes={{
          root: classes.root,
          contained: classes.contained,
          label: classes.label,
        }}
        variant="contained"
      >
        <PhraseMarkdownText className={classes.mainText} phraseKey="conversation.over.downloadAvaApp" />
        <PhraseMarkdownText className={classes.subText} phraseKey="conversation.over.forAMagicalExperience" />
      </Button>
    </a>
  );
};

export default MobileDownloadButton;
